/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  MockERC721,
  MockERC721Interface,
} from "../../../contracts/test/MockERC721";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "someParam",
        type: "uint256",
      },
    ],
    name: "doSomething",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MockERC721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockERC721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockERC721__factory extends ContractFactory {
  constructor(...args: MockERC721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      MockERC721 & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): MockERC721__factory {
    return super.connect(runner) as MockERC721__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockERC721Interface {
    return new Interface(_abi) as MockERC721Interface;
  }
  static connect(address: string, runner?: ContractRunner | null): MockERC721 {
    return new Contract(address, _abi, runner) as unknown as MockERC721;
  }
}
